import request from 'utils/RequestManager';
import config from 'config';

const authURL = config.AUTH_HOST;
const backendURL = config.BACKEND_HOST;

export function authenticate(username, password) {
    return request({
        method: 'post',
        baseURL: authURL,
        url: '/login',
        data: {
            username,
            password,
        },
    });
}

export function logOperatorSession({operatorPlatformId, parentCompanyId, actionType, userAgent}) {
    return request({
        method: 'post',
        baseURL: backendURL,
        url: '/operator-session',
        params: {
            operatorPlatformId,
            parentCompanyId,
            actionType,
        },
        headers: {
            'User-Agent': userAgent || navigator.userAgent,
        },
    });
}

export function getEmail(username) {
    return request({
        method: 'get',
        baseURL: authURL,
        url: '/get-email-by-username?username=' + username,
    });
}

export function getUserContact(operatorId, companyId) {
    return request({
        method: 'get',
        baseURL: backendURL,
        url: `companies/${companyId}/operators/${operatorId}`,
    });
}

export function verifyToken(token) {
    return request({
        method: 'post',
        baseURL: authURL,
        url: `valid/${token}`,
    });
}

export function resetPasswordClick(email) {
    return request({
        method: 'post',
        baseURL: authURL,
        url: `reset`,
        params: {email},
    });
}

export function register(registerData, token) {
    return request({
        method: 'PUT',
        baseURL: authURL,
        url: `/confirm/${token}`,
        data: registerData,
    });
}

export function reset(resetPasswordData, token) {
    return request({
        method: 'PUT',
        baseURL: authURL,
        url: `/reset/${token}`,
        data: resetPasswordData,
    });
}

export function fetchUser(id) {
    return request({
        method: 'GET',
        baseURL: authURL,
        url: '/users',
        params: {
            id,
        },
    }).then(response => response.data);
}

export function updateUser(userInfo) {
    return request({
        method: 'PATCH',
        baseURL: authURL,
        url: '/users',
        data: userInfo,
    }).then(response => response.data);
}

export function updateOperator(userInfo, operatorId) {
    return request({
        method: 'PATCH',
        baseURL: authURL,
        url: `/users/${operatorId}`,
        data: userInfo,
    }).then(response => response.data);
}

export function changePassword(userInfo) {
    return request({
        method: 'POST',
        baseURL: authURL,
        url: '/user/change-password',
        data: userInfo,
    }).then(response => response.data);
}

export function updateLocale(locale) {
    return request({
        method: 'PATCH',
        baseURL: authURL,
        url: '/user/update-locale',
        data: {locale}
    }).then(response => response.data);
}

export function logOutUser() {
    return request({
        method: 'POST',
        baseURL: authURL,
        url: '/logout',
    }).then(response => response);
}



// WEBPACK FOOTER //
// ./src/services/user/api.js